import { TAppTypesDisplaySubsitutes } from 'types/apps'
import { TPermission } from 'types/permissions'

export const setDefaultSelectOption = (
  permissions: TPermission[],
  appName: TAppTypesDisplaySubsitutes
) => {
  // filter all permissions to check if any of them match with passed appName

  const filteredPermissionsByAppName = permissions?.filter(({ subject }) => subject === appName)

  if (filteredPermissionsByAppName?.length) {
    const { action } = filteredPermissionsByAppName[0]
    return { name: action, uuid: action }
  } else {
    return { name: 'VIEW', uuid: 'VIEW' }
  }
}
